import {lifecycle} from 'recompose';

export default lifecycle({

  componentDidUpdate() {
  },

  componentWillReceiveProps(newProps) {
    // console.log('NEW PROPS', newProps)
    if (!this.props.selectedOpticianShop) {
      if (newProps.opticianShops && this.props.loggedInOrganizationId) {
        this.props.updateReferralValue("sender.organizationId", this.props.loggedInOrganizationId)
      } else if (newProps.opticianShops && newProps.opticianShops.length === 1) {
          this.props.updateReferralValue("senderId", newProps.opticianShops[0].organizationId)
      }
    }
    if (!this.props.selectedCareUnit) {
        if (newProps.careUnits && newProps.careUnits.length ===1) {
            this.props.updateReferralValue("receiver.organizationId", newProps.careUnits[0].organizationId)
        }
    }
  },

  componentDidMount() {
    this.props.loadCareUnits();
    this.props.loadOpticianShops();
  }

});